import React, { useState, useRef, useEffect } from "react";
import { LogOut, LayoutDashboard, User, ShieldCheck, ClipboardList } from "lucide-react";
import { useAuth, useUserProfile } from "@/lib/AuthContext";
import { useNavigate, Link } from "react-router-dom";
import NotificationBell from "@/components/notifications/NotificationBell";
import ProfileAvatar from "@/components/layout/ProfileAvatar";

export default function GiveawayHeader({ onLoginClick } = {}) {
  const { isAuthenticated: loggedIn, user: authUser, logout, login } = useAuth();
  const { isAdmin } = useUserProfile();
  const user = authUser ? { full_name: authUser.full_name, email: authUser.email } : null;
  const [open, setOpen] = useState(false);
  const ref = useRef(null);
  const navigate = useNavigate();

  useEffect(() => {
    const handler = (e) => {if (ref.current && !ref.current.contains(e.target)) setOpen(false);};
    document.addEventListener("mousedown", handler);
    return () => document.removeEventListener("mousedown", handler);
  }, []);

  const displayName = user?.full_name || user?.email || "";

  return (
    <header
      className="fixed top-0 left-0 right-0 z-50 w-full"
      style={{ background: "#000000", borderBottom: "1px solid rgba(255,255,255,0.08)" }}
      dir="rtl">
      
      <div className="max-w-5xl mx-auto w-full px-4 py-3 flex flex-col sm:flex-row sm:justify-between sm:items-center gap-2">
        <div className="flex justify-center sm:justify-start w-full sm:w-auto">
          <Link to="/">
            <img
              src="https://media.base44.com/images/public/69b41710d6b60acb7a810a52/fd7ecff3f_momentum_logo.png"
              alt="MOM3NTUM"
              className="h-5 w-auto max-w-full object-contain flex-shrink-0" />
          </Link>
        </div>
        
        <div className="flex items-center justify-center sm:justify-end gap-3 w-full sm:w-auto">
          



          

          {loggedIn && user ? (
          <>
            <NotificationBell />
            <div className="relative" ref={ref}>
              <ProfileAvatar
                user={{ displayName, email: user?.email }}
                onClick={() => setOpen((o) => !o)}
              />
              {open &&
            <div
              className="absolute left-0 top-11 rounded-2xl py-1 min-w-[180px] z-50"
              style={{ background: "#111", border: "1px solid #2a2a2a", boxShadow: "0 8px 32px rgba(0,0,0,0.6)" }}>

                  <div className="px-4 py-3" style={{ borderBottom: "1px solid #1f1f1f" }}>
                    <p className="text-xs font-black text-white truncate">{user.full_name || user.email}</p>
                    <p className="text-xs truncate" style={{ color: "rgba(255,255,255,0.35)" }}>{user.email}</p>
                  </div>
                  <button
                onClick={() => {setOpen(false);navigate("/profile");}}
                className="w-full flex items-center gap-2 px-4 py-2.5 text-sm font-bold transition-colors hover:bg-white/5"
                style={{ color: "#c8f135" }}>

                    <User className="w-3.5 h-3.5" />
                    הפרופיל שלי
                  </button>
                  <button
                onClick={() => {setOpen(false);navigate("/dashboard");}}
                className="w-full flex items-center gap-2 px-4 py-2.5 text-sm font-bold transition-colors hover:bg-white/5"
                style={{ color: "#c8f135" }}>

                    <LayoutDashboard className="w-3.5 h-3.5" />
                    הדשבורד שלי
                  </button>
                  {isAdmin && (
                    <>
                      <div style={{ borderTop: "1px solid #1f1f1f" }} />
                      <button
                        onClick={() => {setOpen(false);navigate("/AdminDashboard");}}
                        className="w-full flex items-center gap-2 px-4 py-2.5 text-sm font-bold transition-colors hover:bg-white/5"
                        style={{ color: "rgba(255,255,255,0.5)" }}>
                        <ShieldCheck className="w-3.5 h-3.5" />
                        ניהול
                      </button>
                      <button
                        onClick={() => {setOpen(false);navigate("/AdminQueue");}}
                        className="w-full flex items-center gap-2 px-4 py-2.5 text-sm font-bold transition-colors hover:bg-white/5"
                        style={{ color: "rgba(255,255,255,0.5)" }}>
                        <ClipboardList className="w-3.5 h-3.5" />
                        תור בדיקה
                      </button>
                    </>
                  )}
                  <button
                onClick={() => logout()}
                className="w-full flex items-center gap-2 px-4 py-2.5 text-sm font-bold transition-colors hover:bg-white/5"
                style={{ color: "rgba(255,80,80,0.85)" }}>

                    <LogOut className="w-3.5 h-3.5" />
                    יציאה
                  </button>
                </div>
            }
            </div>
          </>) :

          <ProfileAvatar
            user={null}
            onClick={() => { onLoginClick ? onLoginClick() : login(); }}
          />
          }
        </div>
      </div>
    </header>);

}